
define('ldsh!modules/lp_leads/templates/navigation', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="pt32 mb32">\n  <div class="ed-title-bar flex align-center gap-8">\n    <button\n      class="btn--link ed-back-button js-back w-44 h-44 p0"\n      data-i18n="[title]common.back"\n    ><i class="ri-arrow-left-s-line f24"></i></button>\n    <h2 class="ed-h-beta js-name-display">\n      <a href="javascript:void(0)" class="js-edit-name">\n        <span>' +
__e(name ) +
'</span>\n      </a>\n    </h2>\n  </div>\n\n  <div class="wrapper mt16">\n    <div class="date-filter-trigger standalone-filter flex align-center gap-8">\n      <div class="flex align-center gap-16 flex-grow-1">\n        <div class="ed-btn ed-btn-secondary-action js-datepicker-button">\n        <span\n          class="txt"\n          data-i18n="landingPage.datepicker.button"\n        >Filtrar por fecha</span>\n        </div>\n        <div class="js-datepicker flex-grow-1"></div>\n      </div>\n    </div>\n  </div>\n\n</div>';

}
return __p
};});

